import { combineEpics } from 'redux-observable'
import DefaultEpics from 'epics/defaultEpics'
import AlgoliaEpics from './algolia'
import AppEpics from './app'
import NavigateToCollectionTypeEpic from './navigate'
export default combineEpics(
  ...DefaultEpics,
  ...AlgoliaEpics,
  ...AppEpics,
  ...NavigateToCollectionTypeEpic
)